
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("alNK3", function(module, exports) {

$parcel$export(module.exports, "default", () => $31920358d599742d$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kFw1p = parcelRequire("kFw1p");

var $1KdDN = parcelRequire("1KdDN");

var $eWzpp = parcelRequire("eWzpp");

var $lvKO5 = parcelRequire("lvKO5");


var $a8l3t = parcelRequire("a8l3t");

var $3mc1g = parcelRequire("3mc1g");
const $31920358d599742d$var$UpgradeEditionMenuItemNew = ({ setUpgradeEditionMenuShown: setUpgradeEditionMenuShown })=>{
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const { data: projectData, loading: projectDataLoading } = (0, $eWzpp.useProject)();
    const { isSiteAdmin: isSiteAdmin } = tenantContext;
    const explicitlyLicensedProducts = (0, $kFw1p.default)(tenantContext);
    const applicationKey = (0, $a8l3t.getActivePageApplicationKey)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    projectData?.type, explicitlyLicensedProducts);
    const shouldRender = (0, $a8l3t.shouldRenderMenuItem)(isSiteAdmin, applicationKey, explicitlyLicensedProducts, tenantContext);
    (0, $eJOHy.useEffect)(()=>{
        if (projectDataLoading) return;
        // Add separator bar in the menu if the menu item should be rendered
        setUpgradeEditionMenuShown(shouldRender);
    }, [
        projectDataLoading,
        setUpgradeEditionMenuShown,
        shouldRender
    ]);
    if (projectDataLoading) return null;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1KdDN.JSErrorBoundary), {
        id: (0, $9ffb12252fb9c37a$export$5fa54bc771a7eb8f),
        packageName: (0, $9ffb12252fb9c37a$export$b8b9d90f9e5bd72b),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3mc1g.default), {
        product: applicationKey
    }));
};
var $31920358d599742d$export$2e2bcd8739ae039 = $31920358d599742d$var$UpgradeEditionMenuItemNew;

});
const $9ffb12252fb9c37a$export$195e756c24f2ef95 = 'persistent-upgrade';
const $9ffb12252fb9c37a$export$2c864ccb7debe0d4 = 'persistentUpgrade';
const $9ffb12252fb9c37a$export$b8b9d90f9e5bd72b = 'persistentUpgrade';
const $9ffb12252fb9c37a$export$5fa54bc771a7eb8f = 'persistentUpgradeMenu';
const $9ffb12252fb9c37a$export$2b421d13e998fdbb = 'persistentUpgradeMenu clicked';
const $9ffb12252fb9c37a$export$23de212b4b92e749 = 'persistentUpgradeMenu viewed';

parcelRegister("a8l3t", function(module, exports) {

$parcel$export(module.exports, "shouldRenderMenuItem", () => $c76247ca17744c2b$export$6335c904eace2f3);
$parcel$export(module.exports, "getFreeEditionMenuItem", () => $c76247ca17744c2b$export$cce6104d08ee5a15);
$parcel$export(module.exports, "getActivePageApplicationKey", () => $c76247ca17744c2b$export$44df08af6d5522d3);
$parcel$export(module.exports, "getHref", () => $c76247ca17744c2b$export$81842c1ae19d378b);

var $ln6Iy = parcelRequire("ln6Iy");

var $95m1j = parcelRequire("95m1j");


var $a9ldn = parcelRequire("a9ldn");

var $5uDlp = parcelRequire("5uDlp");
const $c76247ca17744c2b$var$isFreeEdition = (product, tenantContext)=>{
    const productEdition = (0, $95m1j.getProductEdition)(product, tenantContext);
    return productEdition === (0, $a9ldn.FREE_EDITION);
};
const $c76247ca17744c2b$var$productIsJSMOrJSW = (product)=>product === (0, $e08dff4ae358d899$export$1346c9aa3cbb477d) || product === (0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61);
const $c76247ca17744c2b$var$hasFreeJSMOrJSW = (explicitlyLicensedProducts, tenantContext)=>explicitlyLicensedProducts.some((product)=>$c76247ca17744c2b$var$productIsJSMOrJSW(product) && $c76247ca17744c2b$var$isFreeEdition(product, tenantContext));
const $c76247ca17744c2b$export$6335c904eace2f3 = (isSiteAdmin, product, explicitlyLicensedProducts, tenantContext)=>{
    if (!isSiteAdmin) return false;
    if (!product) // If we're on a product-agnostic page (e.g "Your Work") we can still render the menu item
    // as long as there is a free JSM or JSW. The menu item will link to the "Manage Subscriptions" page.
    return $c76247ca17744c2b$var$hasFreeJSMOrJSW(explicitlyLicensedProducts, tenantContext);
    // If we're in JSM or JSW Free, render the menu item.
    if (product && $c76247ca17744c2b$var$productIsJSMOrJSW(product)) return $c76247ca17744c2b$var$isFreeEdition(product, tenantContext);
    return false;
};
const $c76247ca17744c2b$export$cce6104d08ee5a15 = (intl, trialLength)=>({
        heading: intl().formatMessage((0, $5uDlp.default).upgrade),
        content: intl().formatMessage((0, $5uDlp.default).tryStandardPlan),
        tagContent: intl().formatMessage((0, $5uDlp.default).trialPeriod, {
            trialLength: trialLength
        }),
        lozengeAppearance: 'inprogress',
        touchpointId: 'preTrialMenu',
        flowId: 'upgradeFlow',
        displayUpflowModal: true
    });
const $c76247ca17744c2b$export$636823a5af1468e4 = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $e08dff4ae358d899$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61;
    if (subProduct === 'core') return 0, $e08dff4ae358d899$export$db515c8cec1e6f79;
    // If subProduct is null, we may be on a product-agnostic page e.g. "Your Work"
    // In there is only one licensed product, we can infer what the user is using
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};
const $c76247ca17744c2b$export$b6487772e5a4e151 = (projectType)=>{
    switch(projectType){
        case 0, $ln6Iy.SOFTWARE_PROJECT:
            return 0, $e08dff4ae358d899$export$1346c9aa3cbb477d;
        case 0, $ln6Iy.SERVICE_DESK_PROJECT:
            return 0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61;
        case 0, $ln6Iy.CORE_PROJECT:
            return 0, $e08dff4ae358d899$export$db515c8cec1e6f79;
        case 0, $ln6Iy.PRODUCT_DISCOVERY_PROJECT:
            return 0, $e08dff4ae358d899$export$202f50ee62667e32;
        default:
            return null;
    }
};
const $c76247ca17744c2b$export$44df08af6d5522d3 = (projectType, explicitlyLicensedProducts)=>{
    const applicationKey = $c76247ca17744c2b$export$b6487772e5a4e151(projectType);
    if (applicationKey !== null) return applicationKey;
    // If applicationKey is null, we may be on a product-agnostic page e.g. "Your Work"
    // In there is only one licensed product, we can infer what the user is using
    if (explicitlyLicensedProducts.length === 1) return explicitlyLicensedProducts[0];
    return null;
};
const $c76247ca17744c2b$export$81842c1ae19d378b = (freeEditionMenuItemInfo, product)=>{
    if (!product) return '/admin/billing/applications';
    return freeEditionMenuItemInfo.href ? freeEditionMenuItemInfo.href(freeEditionMenuItemInfo.touchpointId) : '';
};

});
parcelRegister("95m1j", function(module, exports) {

$parcel$export(module.exports, "getProductEdition", () => $9e8527d9d77db859$export$53e066a63a960439);

const $9e8527d9d77db859$export$53e066a63a960439 = (product, tenantContext)=>{
    if (product === (0, $e08dff4ae358d899$export$1346c9aa3cbb477d)) return tenantContext.appEditions.software;
    if (product === (0, $e08dff4ae358d899$export$c8c1c8c3f8ddba61)) return tenantContext.appEditions.serviceDesk;
    return tenantContext.appEditions.core;
};

});
const $e08dff4ae358d899$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $e08dff4ae358d899$export$e9c56aa3b027d98f = 'jira-customer-service';
const $e08dff4ae358d899$export$1346c9aa3cbb477d = 'jira-software';
const $e08dff4ae358d899$export$202f50ee62667e32 = 'jira-product-discovery';
const $e08dff4ae358d899$export$db515c8cec1e6f79 = 'jira-core';
const $e08dff4ae358d899$export$c811f21c9ad05dc2 = 'confluence';
const $e08dff4ae358d899$export$961148c98d198270 = 'opsgenie';


parcelRegister("5uDlp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7ef322120abc3d1$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
var $a7ef322120abc3d1$export$2e2bcd8739ae039 = (0, $7qGN1.defineMessages)({
    upgrade: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.upgrade",
        "defaultMessage": "Upgrade"
    },
    tryStandardPlan: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.try-standard-plan",
        "defaultMessage": "Try the Standard plan"
    },
    trialPeriod: {
        "id": "atlassian-navigation.profile.menu.upgrade-edition.trial-period",
        "defaultMessage": "free {trialLength}-day trial"
    }
});

});


parcelRegister("3mc1g", function(module, exports) {

$parcel$export(module.exports, "default", () => $99acf96ad176109f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eIhG2 = parcelRequire("eIhG2");

var $6alcT = parcelRequire("6alcT");

var $eRYig = parcelRequire("eRYig");

var $95m1j = parcelRequire("95m1j");

var $dTocu = parcelRequire("dTocu");

var $gCeeo = parcelRequire("gCeeo");
var $iqtgH = parcelRequire("iqtgH");
var $f1Zdy = parcelRequire("f1Zdy");

var $a9ldn = parcelRequire("a9ldn");

var $lvKO5 = parcelRequire("lvKO5");

var $ieLlb = parcelRequire("ieLlb");

var $8PILw = parcelRequire("8PILw");

var $1hBLh = parcelRequire("1hBLh");

var $b5gS8 = parcelRequire("b5gS8");


var $a8l3t = parcelRequire("a8l3t");
const $99acf96ad176109f$var$LozengeContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $99acf96ad176109f$export$4a94253c58c6e2cb = ({ product: product })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $f1Zdy.useAnalyticsEvents)();
    const tenantContext = (0, $lvKO5.useTenantContext)();
    const productEdition = product ? (0, $95m1j.getProductEdition)(product, tenantContext) : (0, $a9ldn.FREE_EDITION);
    const trialLength = (0, $ieLlb.getTrialLength)(productEdition, (0, $a9ldn.STANDARD_EDITION));
    // eslint-disable-next-line react-hooks/react-compiler
    const freeEditionMenuItemInfo = (0, $a8l3t.getFreeEditionMenuItem)((0, $dTocu.useIntlV2), trialLength);
    const [, { mountUpflowModal: mountUpflowModal }] = (0, $8PILw.useUpflowModal)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iqtgH.FireUiAnalytics), {
        eventName: (0, $9ffb12252fb9c37a$export$23de212b4b92e749),
        attributes: {
            currentEdition: productEdition,
            growthFeature: (0, $9ffb12252fb9c37a$export$2c864ccb7debe0d4),
            touchpointId: freeEditionMenuItemInfo.touchpointId,
            flowId: freeEditionMenuItemInfo.flowId,
            computedProduct: product
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eRYig.default), null, freeEditionMenuItemInfo.heading), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuList), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b5gS8.MenuListItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1hBLh.MenuItem), {
        analytics: {
            actionSubjectId: 'persistentUpgradeNavigationMenuItem',
            menuItemId: freeEditionMenuItemInfo.touchpointId,
            menuItemType: 'action',
            position: 0
        },
        onClick: ()=>{
            const analyticEvent = createAnalyticsEvent({});
            (0, $gCeeo.fireUIAnalytics)(analyticEvent, (0, $9ffb12252fb9c37a$export$2b421d13e998fdbb), {
                currentEdition: productEdition,
                growthFeature: (0, $9ffb12252fb9c37a$export$2c864ccb7debe0d4),
                touchpointId: freeEditionMenuItemInfo.touchpointId,
                flowId: freeEditionMenuItemInfo.flowId,
                computedProduct: product
            });
            if (product && freeEditionMenuItemInfo.displayUpflowModal === true) mountUpflowModal({
                targetEdition: (0, $a9ldn.STANDARD_EDITION),
                product: product,
                flow: (0, $9ffb12252fb9c37a$export$195e756c24f2ef95),
                touchpointId: freeEditionMenuItemInfo.touchpointId
            });
        },
        href: (0, $a8l3t.getHref)(freeEditionMenuItemInfo, product),
        target: product ? undefined : '_blank',
        iconAfter: product ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eIhG2))), {
            LEGACY_size: "small",
            color: "var(--ds-icon-subtle, #626F86)",
            label: ""
        })
    }, freeEditionMenuItemInfo.content, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($99acf96ad176109f$var$LozengeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6alcT.default), {
        appearance: freeEditionMenuItemInfo.lozengeAppearance,
        isBold: true
    }, freeEditionMenuItemInfo.tagContent, ' '))))));
};
var $99acf96ad176109f$export$2e2bcd8739ae039 = $99acf96ad176109f$export$4a94253c58c6e2cb;

});
parcelRegister("ieLlb", function(module, exports) {

$parcel$export(module.exports, "getTrialLength", () => $1ed90f1f6f4fab5b$export$23d271f9e8cb9c4);

var $a9ldn = parcelRequire("a9ldn");

const $1ed90f1f6f4fab5b$export$23d271f9e8cb9c4 = (currentEdition, targetEdition)=>{
    if (currentEdition === (0, $a9ldn.FREE_EDITION) && targetEdition === (0, $a9ldn.STANDARD_EDITION)) return 0, $e07be5da6c48abf4$export$b7a3952d12e24333;
    return 0, $e07be5da6c48abf4$export$940ef4a039f45970;
};

});
const $e07be5da6c48abf4$export$b7a3952d12e24333 = 14;
const $e07be5da6c48abf4$export$940ef4a039f45970 = 30;


parcelRegister("8PILw", function(module, exports) {

$parcel$export(module.exports, "useUpflowModal", () => $6e82c436675b8525$export$7025cc2729b71e44);

var $a9ldn = parcelRequire("a9ldn");

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");
var $ht3nQ = parcelRequire("ht3nQ");

const $6e82c436675b8525$var$initialState = {
    renderUpflowModal: false,
    product: 'jira-software',
    touchpointId: '',
    flow: 'learn-more',
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onClose: ()=>{},
    targetEdition: (0, $a9ldn.FREE_EDITION)
};
const $6e82c436675b8525$var$actions = {
    mountUpflowModal: ({ targetEdition: targetEdition, product: product, flow: flow, touchpointId: touchpointId, subRoute: subRoute, onClose: onClose, onOpen: onOpen })=>({ setState: setState })=>{
            setState({
                targetEdition: targetEdition,
                product: product,
                flow: flow,
                touchpointId: touchpointId,
                subRoute: subRoute,
                onClose: onClose,
                onOpen: onOpen,
                renderUpflowModal: true
            });
        },
    unMountUpflowModal: ()=>({ setState: setState })=>{
            setState({
                renderUpflowModal: false
            });
        }
};
const $6e82c436675b8525$var$Store = (0, $GtRbT.createStore)({
    name: (0, $9b7b66af426873ce$export$675a4427bf3750a2),
    initialState: $6e82c436675b8525$var$initialState,
    actions: $6e82c436675b8525$var$actions
});
const $6e82c436675b8525$export$6d73384be122c2dd = (0, $ht3nQ.createSubscriber)($6e82c436675b8525$var$Store);
const $6e82c436675b8525$export$e672be732bd57171 = (0, $6E16M.createContainer)($6e82c436675b8525$var$Store);
const $6e82c436675b8525$export$7025cc2729b71e44 = (0, $iJq0l.createHook)($6e82c436675b8525$var$Store);

});
const $9b7b66af426873ce$export$675a4427bf3750a2 = 'upflow-modal-store';





$parcel$global.rlb("1rdej")
//# sourceMappingURL=upgrade-edition-menu-item.1e2c43d9.js.map
